var map = {
	"./advanced-icon.svg": 84870,
	"./arrow-back.svg": 11531,
	"./arrow-down-icon.svg": 12816,
	"./arrow-left-icon.svg": 97761,
	"./arrow-left-solid-icon.svg": 3559,
	"./arrow-right-icon.svg": 84930,
	"./attachment-icon.svg": 73301,
	"./audit.svg": 45531,
	"./avatar-placeholder.svg": 31945,
	"./basic-info-icon.svg": 17601,
	"./bell-icon.svg": 8205,
	"./calendar.svg": 13960,
	"./cancel-icon.svg": 63646,
	"./check-filled-icon.svg": 52811,
	"./check-icon.svg": 38140,
	"./check-off-icon.svg": 28684,
	"./check-on-icon.svg": 61374,
	"./checkmark-icon.svg": 97545,
	"./chevron-right.svg": 35026,
	"./close-icon.svg": 36408,
	"./collab-icon.svg": 47501,
	"./company-deps-icon.svg": 8188,
	"./company-icon.svg": 54155,
	"./dashboard-icon.svg": 25708,
	"./date-picker-icon.svg": 24425,
	"./delete-icon.svg": 71103,
	"./docs-icon.svg": 52015,
	"./drag-icon.svg": 88242,
	"./dropbox.svg": 55916,
	"./dropdown-icon.svg": 69833,
	"./eye-icon.svg": 64289,
	"./file-icon.svg": 48018,
	"./filter-icon.svg": 88978,
	"./filter-pure-icon.svg": 13991,
	"./filter-selected-icon.svg": 4268,
	"./flag-icon.svg": 81194,
	"./gift.svg": 95396,
	"./icon-account-circle.svg": 94956,
	"./icon-account.svg": 17551,
	"./icon-add-link.svg": 64884,
	"./icon-add-note.svg": 8688,
	"./icon-add.svg": 8539,
	"./icon-approve-circle.svg": 56222,
	"./icon-arrow-back.svg": 38679,
	"./icon-arrow-down-circle.svg": 83919,
	"./icon-arrow.svg": 96085,
	"./icon-article.svg": 79680,
	"./icon-assignment.svg": 57141,
	"./icon-box.svg": 14133,
	"./icon-briefcases.svg": 5925,
	"./icon-cancel-circle-stroke.svg": 43662,
	"./icon-cancel-circle.svg": 27445,
	"./icon-cancel.svg": 2056,
	"./icon-check-circle.svg": 24739,
	"./icon-check.svg": 11334,
	"./icon-circle.svg": 18158,
	"./icon-conformio-cloud.svg": 33352,
	"./icon-dashboard.svg": 81302,
	"./icon-database.svg": 3861,
	"./icon-document-excel.svg": 43067,
	"./icon-document-w-s.svg": 64241,
	"./icon-document-word.svg": 47862,
	"./icon-document.svg": 68981,
	"./icon-download.svg": 93958,
	"./icon-dropbox.svg": 27392,
	"./icon-edit.svg": 13810,
	"./icon-emergency.svg": 67945,
	"./icon-error.svg": 26748,
	"./icon-event-note.svg": 28723,
	"./icon-evidence.svg": 34713,
	"./icon-exclamation-circle.svg": 3918,
	"./icon-external-link.svg": 20036,
	"./icon-eye.svg": 29849,
	"./icon-feature-search.svg": 12313,
	"./icon-filter.svg": 37108,
	"./icon-folder-open.svg": 15611,
	"./icon-folder.svg": 67102,
	"./icon-folders.svg": 17825,
	"./icon-help.svg": 63863,
	"./icon-image.svg": 77117,
	"./icon-info.svg": 73854,
	"./icon-lab-profile.svg": 27787,
	"./icon-license.svg": 67487,
	"./icon-line-arrow.svg": 87692,
	"./icon-link.svg": 87566,
	"./icon-logo.svg": 91111,
	"./icon-maintenance.svg": 42743,
	"./icon-module.svg": 51682,
	"./icon-more.svg": 57633,
	"./icon-note.svg": 67074,
	"./icon-pdf.svg": 27000,
	"./icon-percentage.svg": 96886,
	"./icon-person.svg": 21269,
	"./icon-phone-message.svg": 96532,
	"./icon-plus.svg": 82202,
	"./icon-point-circle.svg": 29433,
	"./icon-preonboarding-background-alpha.svg": 3876,
	"./icon-preonboarding-background-beta.svg": 40622,
	"./icon-preonboarding-email.svg": 43125,
	"./icon-privacy.svg": 32574,
	"./icon-questionmark-circle.svg": 11414,
	"./icon-quick-reference.svg": 7063,
	"./icon-record.svg": 99101,
	"./icon-refresh-circle.svg": 82888,
	"./icon-search.svg": 59982,
	"./icon-settings.svg": 85229,
	"./icon-sharepoint.svg": 36711,
	"./icon-slack.svg": 49982,
	"./icon-step.svg": 50891,
	"./icon-storage.svg": 18925,
	"./icon-suitcase.svg": 30729,
	"./icon-task.svg": 8485,
	"./icon-today.svg": 87993,
	"./icon-training.svg": 34576,
	"./icon-transfer.svg": 36491,
	"./icon-trash.svg": 84768,
	"./icon-user-add.svg": 34897,
	"./icon-user-circle.svg": 60756,
	"./icon-user-remove.svg": 50712,
	"./icon-videocam.svg": 64552,
	"./incidents.svg": 76291,
	"./info-icon.svg": 34476,
	"./iso-icon.svg": 93985,
	"./link-attachment-icon.svg": 19630,
	"./link-icon.svg": 20356,
	"./link-with-background-icon.svg": 2406,
	"./loader.svg": 3627,
	"./log-out.svg": 50239,
	"./management-review.svg": 63076,
	"./minus.svg": 53150,
	"./my-work-icon.svg": 74336,
	"./nonconformity.svg": 77705,
	"./notification-close-icon.svg": 67638,
	"./notification-update-icon.svg": 17887,
	"./notification-warning-icon.svg": 47310,
	"./ok-icon.svg": 95378,
	"./ok-secondary.svg": 91761,
	"./paragraph-icon.svg": 50918,
	"./pencil-filled-icon.svg": 3932,
	"./pencil-icon.svg": 69893,
	"./people-icon.svg": 33427,
	"./plus-add-icon.svg": 25942,
	"./plus-icon-round.svg": 85631,
	"./plus-icon.svg": 52576,
	"./premium.svg": 66301,
	"./print-icon.svg": 23519,
	"./recurring.svg": 68203,
	"./register-req.svg": 34458,
	"./regs-icon.svg": 83843,
	"./remove-icon.svg": 25752,
	"./report-icon.svg": 95286,
	"./reporting.svg": 62100,
	"./resp-matrix-icon.svg": 40936,
	"./risk-register.svg": 63555,
	"./search-icon.svg": 6012,
	"./security-objectives-icon.svg": 90077,
	"./security-objectives.svg": 24345,
	"./semaphore-icon.svg": 92250,
	"./sharepoint.svg": 13843,
	"./simple-icon.svg": 92062,
	"./soa.svg": 21617,
	"./sort-arrow-icon.svg": 22240,
	"./sort-arrow-one-icon.svg": 42785,
	"./subscribe-check-icon.svg": 42793,
	"./time-icon.svg": 39489,
	"./training.svg": 10780,
	"./update-profile-image.svg": 89797,
	"./warning-icon.svg": 43104,
	"./working-with-conformio-icon.svg": 42809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97130;